import { useContext } from "react";
import PageSection from "./PageSection";
import FormField from "../Input/FormField";
import { STATE_LIST } from "../../data/constants";
import Button from "../Input/Button";
import Dropdown from "../Input/Dropdown";
import PaymentCards from "../PaymentCards/PaymentCards";
import { useHistory } from "react-router-dom";
import Context from "../../../context";

export default function PaymentMethodPageSection({
  form,
  hasExisting,
  title,
  paymentView,
  setPaymentView,
  setValue,
  noOptions = false,
  setSelectedMethod,
  isGlobal = false,
  isAutopay = false,
  allowBankDraft,
}) {
  const { contextState, setContextState } = useContext(Context);
  const history = useHistory();
  let userRole = localStorage.getItem("userRole");

  return (
    <PageSection sectionName={title} isForm>
      {!noOptions && (
        <>
          <ul className="nav mx-n3">
            {hasExisting && (
              <li className="nav-item">
                <div className="nav-link">
                  <div
                    className={`radio${
                      paymentView === "existing" ? " selected" : ""
                    }`}
                    onClick={() => setPaymentView("existing")}>
                    <div className="radio-input" />
                    <label className="radio-label">Use Existing Method</label>
                  </div>
                </div>
              </li>
            )}
            <li className="nav-item">
              { userRole !== "IT-User" && (
              <div className="nav-link">
                <div
                  className={`radio${
                    paymentView === "card" ? " selected" : ""
                  }`}
                  onClick={() => {
                    setPaymentView("card");
                  }}>
                  
                  <div className="radio-input" />
                  <label className="radio-label">
                    Add Credit or Debit Card
                  </label>
                </div>
              </div>
              )}
            </li>
            { allowBankDraft && (
            <li className="nav-item">
              <div className="nav-link">
                <div
                  className={`radio${
                    paymentView === "bank" ? " selected" : ""
                  }`}
                  onClick={() => {
                    setPaymentView("bank");
                  }}>
                  <div className="radio-input" />
                  <label className="radio-label">Add Bank Draft</label>
                </div>
              </div>
            </li>
            )}
          </ul>
          <hr className="mx-0" />
        </>
      )}
      {paymentView === "existing" && hasExisting && (
        <PaymentCards
          setSelectedMethod={setSelectedMethod}
          isGlobal={isGlobal}
          isAutopay={isAutopay}
        />
      )}
      {paymentView === "card" && (
        <div className="form-container">
          <h4>Account Details</h4>
          <div className="page-subsection">
            <FormField
              field="accountName"
              type="text"
              name="Name on Account"
              form={form}
            />
            <FormField
              field="billingAddress"
              type="text"
              name="Address"
              form={form}
            />
            <FormField
              field="accountAddress2"
              type="text"
              name="Address 2"
              form={form}
              noLabel
              helpText="Company, C/O, Apt., Suite, Unit, Building, Floor, etc..."
              optional
            />
            <div className="form-row">
              <div className="col-lg-5">
                <FormField
                  field="billingAddressCity"
                  type="text"
                  name="City"
                  form={form}
                />
              </div>
              <div className="col-lg-4">
                <Dropdown setValue={setValue} text="State" data={STATE_LIST} />
              </div>
              <div className="col-lg-3">
                <FormField
                  field="billingAddressZipCode"
                  type="text"
                  name="Zip Code"
                  form={form}
                />
              </div>
            </div>
          </div>
          <h4>Card Details</h4>
          <div className="page-subsection">
            <FormField
              field="firstName"
              type="text"
              name="Cardholder Name"
              form={form}
            />
            <FormField
              field="creditCardNumber"
              type="text"
              name="Card Number"
              form={form}
            />
            <div className="row">
              <div className="col-lg-3">
                <FormField
                  field="expirationDate"
                  type="text"
                  name="Exp. Date"
                  form={form}
                />
              </div>
              <div className="col-lg-3">
                <FormField
                  field="creditCardCode"
                  type="text"
                  name="CVC/CVV2/CID"
                  form={form}
                />
              </div>
              {/* <div className="col-4">
                    <FormField
                      field="cardZip"
                      type="text"
                      name="Zip Code"
                      form={form}
                    />
                  </div> */}
            </div>
          </div>
          <Button
            className="btn btn--green btn--bordered"
            text="Add Payment Method"
            type="submit"
            disabled={!(form.dirty && form.isValid)}
          />
        </div>
      )}
      {paymentView === "bank" && allowBankDraft &&(
        <>
          <div className="form-container">
            <h4>Account Details</h4>
            <div className="page-subsection">
              <FormField
                field="accountName"
                type="text"
                name="Name on Account"
                form={form}
              />
              <FormField
                field="billingAddress"
                type="text"
                name="Address"
                form={form}
              />
              <FormField
                field="billingAddress2"
                type="text"
                name="Address 2"
                form={form}
                noLabel
                helpText="Company, C/O, Apt., Suite, Unit, Building, Floor, etc..."
                optional
              />
              <div className="form-row">
                <div className="col-lg-5">
                  <FormField
                    field="billingAddressCity"
                    type="text"
                    name="City"
                    form={form}
                  />
                </div>
                <div className="col-lg-4">
                  {/*accountState*/}
                  <Dropdown
                    text="State"
                    data={STATE_LIST}
                    setValue={setValue}
                  />
                </div>
                <div className="col-lg-3">
                  <FormField
                    field="billingAddressZipCode"
                    type="text"
                    name="Zip Code"
                    form={form}
                  />
                </div>
              </div>
            </div>
            <h4>Bank Account Details</h4>
            <div className="page-subsection">
              <FormField
                field="bankRoutingNumber"
                type="text"
                name="Routing Number"
                form={form}
              />
              <FormField
                field="bankAccountNumber"
                type="text"
                name="Account Number"
                form={form}
              />
              <FormField
                field="reAccountNumber"
                type="text"
                name="Re-enter Account Number"
                form={form}
              />
              <FormField
                field="bankNameOnAccount"
                type="text"
                name="Bank Name"
                form={form}
              />
            </div>
          </div>
          <Button
            className="btn btn--green btn--bordered"
            text="Add Payment Method"
            type="submit"
            disabled={!(form.dirty && form.isValid)}
          />
        </>
      )}
      {noOptions && !isGlobal && (
        <Button
          className="btn btn--green btn--bordered"
          text="Add Payment Method"
          onClick={() => {
            history.push(
              `/account/${contextState.currentAccountId}/payment-methods`
            );
          }}
        />
      )}
    </PageSection>
  );
}
